/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Msg_Request_SentInputs */

const en_msg_request_sent = /** @type {(inputs: Msg_Request_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your request to join has been sent to the owner.`)
};

const es_msg_request_sent = /** @type {(inputs: Msg_Request_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu solicitud para unirte se ha enviado al propietario.`)
};

const fr_msg_request_sent = /** @type {(inputs: Msg_Request_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre demande d'adhésion a été envoyée au propriétaire.`)
};

const de_msg_request_sent = /** @type {(inputs: Msg_Request_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Beitrittsanfrage wurde an den Eigentümer gesendet.`)
};

const id_msg_request_sent = /** @type {(inputs: Msg_Request_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permintaan Anda untuk bergabung telah dikirim ke pemilik.`)
};

/** @type {(inputs: Msg_Request_SentInputs) => LocalizedString} */
const ja_msg_request_sent = en_msg_request_sent;

/** @type {(inputs: Msg_Request_SentInputs) => LocalizedString} */
const zh_msg_request_sent = en_msg_request_sent;

/** @type {(inputs: Msg_Request_SentInputs) => LocalizedString} */
const ar_msg_request_sent = en_msg_request_sent;

/** @type {(inputs: Msg_Request_SentInputs) => LocalizedString} */
const it_msg_request_sent = en_msg_request_sent;

/** @type {(inputs: Msg_Request_SentInputs) => LocalizedString} */
const ru_msg_request_sent = en_msg_request_sent;

/** @type {(inputs: Msg_Request_SentInputs) => LocalizedString} */
const pt_msg_request_sent = en_msg_request_sent;

/** @type {(inputs: Msg_Request_SentInputs) => LocalizedString} */
const ko_msg_request_sent = en_msg_request_sent;

/**
* | output |
* | --- |
* | "Your request to join has been sent to the owner." |
*
* @param {Msg_Request_SentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const msg_request_sent = /** @type {((inputs?: Msg_Request_SentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Msg_Request_SentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_msg_request_sent(inputs)
	if (locale === "es") return es_msg_request_sent(inputs)
	if (locale === "fr") return fr_msg_request_sent(inputs)
	if (locale === "de") return de_msg_request_sent(inputs)
	if (locale === "ja") return ja_msg_request_sent(inputs)
	if (locale === "zh") return zh_msg_request_sent(inputs)
	if (locale === "ar") return ar_msg_request_sent(inputs)
	if (locale === "id") return id_msg_request_sent(inputs)
	if (locale === "it") return it_msg_request_sent(inputs)
	if (locale === "ru") return ru_msg_request_sent(inputs)
	if (locale === "pt") return pt_msg_request_sent(inputs)
	return ko_msg_request_sent(inputs)
});